import React from 'react'
import Logo from './../images/Dansave-Logo_Dark.png'
import './Header.scss'
import {mainUrl} from '../data'

export default () => <div className="header">
  <a href={mainUrl}>
    <img alt="Dansave" className="logo" src={Logo} />
  </a>
</div>